/**
 * Temporary local dev: set REACT_APP_BYPASS_AUTH=true in .env.development.local
 * (then restart `npm start`). UI loads without login; API calls still hit the
 * server without a Bearer token unless you add one elsewhere.
 */
export const isDevAuthBypassEnabled = (): boolean =>
  process.env.REACT_APP_BYPASS_AUTH === 'true';

const full = { create: true, read: true, update: true, delete: true };

export const devBypassMockUser = {
  id: '00000000-0000-0000-0000-000000000001',
  username: 'dev-bypass@local',
  first_name: 'Dev',
  last_name: 'Bypass',
  analytic_profiles: [],
  permissions: {
    users: { ...full },
    analytic_profiles: { ...full },
    company_profile: { ...full },
    social_listening: { ...full },
    content_radar: { ...full },
    social_studio: { ...full },
    idea_sparker: { ...full },
    notebooks: { ...full },
    podcasts: { ...full },
    clusters: { ...full },
    images: { ...full },
  },
};
